export default "__VITE_ASSET__Chx28Mfk__"